export default __webpack_public_path__ + "images/262ca89d87e99f250dd46273997f6e89-language.svg";